function TableRow({ children, className, ...rest }) {
  return (
    <tr {...rest} className={className}>
      {children}
    </tr>
  );
}

export default TableRow;
